import {
  Badge,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import type { ReportClientItem } from 'services/interfaces/storeGroupReport';
import { formatCurrency, formatPhone } from './reportFormat';

interface ReportClientsTableProps {
  data: ReportClientItem[];
}

// Só leitura por agora — sem o disparo de WhatsApp que a aba Clientes da franquia tem no
// ionic (decisão do Eden: fica pra outra fatia).
const ReportClientsTable: React.FC<ReportClientsTableProps> = ({ data }) => {
  if (data.length === 0) {
    return (
      <Text color="gray.500" py="2rem" textAlign="center">
        Nenhum cliente no período.
      </Text>
    );
  }

  return (
    <TableContainer>
      <Table size="sm">
        <Thead>
          <Tr>
            <Th>Cliente</Th>
            <Th isNumeric>Saldo</Th>
            <Th isNumeric>Acumulado</Th>
            <Th isNumeric>Resgatado</Th>
            <Th isNumeric>Lojas</Th>
            <Th>Status</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((row) => (
            <Tr key={row.phone}>
              <Td>
                <Text>{row.name}</Text>
                <Text fontSize="xs" color="gray.500">
                  {formatPhone(row.phone)}
                </Text>
              </Td>
              <Td isNumeric>{formatCurrency(row.balance)}</Td>
              <Td isNumeric>{formatCurrency(row.accumulated)}</Td>
              <Td isNumeric>{formatCurrency(row.redeemed)}</Td>
              <Td isNumeric>{row.store_count}</Td>
              <Td>
                <Badge colorScheme={row.status === 'ACTIVE' ? 'green' : 'gray'}>
                  {row.status === 'ACTIVE' ? 'Ativo' : 'Inativo'}
                </Badge>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default ReportClientsTable;
